import { View, Text, ImageBackground } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage';
import ttptr from './../teamsThatPlayThisRound';
import dr from './../datosReferenciales.json';
import { useNavigation } from '@react-navigation/native';
import transl from './../translations/transl'
import { useSelector } from 'react-redux';

let lang = 0;

const CupInfo = ({route}) => {
  const nameOfCup = route.params
  const navigation = useNavigation();

  useLayoutEffect(() => {
    navigation.setOptions({
        headerTitle: transl('General.'+nameOfCup,lang)//dr.nombresDeCopa[nameOfCup]
    })
}, []);

  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
    })
  }
  readValue()

  lang = dr.idiomas[useSelector((state) => state.language)].value
    
  return (
    <ImageBackground source={require('./../img/background5.png')} resizeMode="cover" style={{flex:1}}>
      <View style={{margin:20,paddingVertical:20,paddingHorizontal:30,backgroundColor:'#ffffff',elevation:1,borderRadius:20}}>
          <Text style={{fontSize:20,marginLeft:'auto',marginRight:'auto',marginBottom:15}}>{transl('General.'+nameOfCup,lang)}</Text>
          {displayInfo(value,nameOfCup)}
      </View>
    </ImageBackground>
  )
}

function displayInfo(data,nameOfCup){
  if(data === undefined || !data) return
  data = data != null ? JSON.parse(data) : null

  let jornadaReal = data.others.siguientePartido
  if(data.others.vecesTodosLosPartidosHechos%2) jornadaReal += 19
  const cup = data.others.championships[nameOfCup];
  if(cup.equipos[0].id == 1) {
    const indicesEnCopa = ttptr(cup)
    if(cup.equipos[indicesEnCopa[0]].id == 1 && indicesEnCopa.length > 1) {
      let resultsOfThisRound = []
      for(let i = 1; i < ((cup.currentRound % (cup.gamesPerRound))+1); i++){
        const result1 = cup.equipos[0].results[cup.equipos[0].results.length-i]
        const result2 = cup.equipos[indicesEnCopa[1]].results[cup.equipos[indicesEnCopa[1]].results.length-i]
        let textColor = {fontWeight:'bold'}
        if(result1[0] > result2[0]) textColor.color = '#00ff00'
        else textColor.color = '#ff0000'
        resultsOfThisRound.unshift(<Text style={textColor}>{result1} - {result2}</Text>)
      }
      if(resultsOfThisRound.length == 0) resultsOfThisRound.push(<Text>{transl('Cups.ningunPartido',lang)}</Text>)
      return <View>
          <Text>{transl('Cups.proximoPartido',lang,[dr.tiposDeCopa[Math.log2(indicesEnCopa.length)-1],((cup.currentRound % (cup.gamesPerRound)) + 1),cup.gamesPerRound,data.teams[cup.equipos[indicesEnCopa[1]].id-1].name])}</Text>
          <Text>{transl('Cups.fechaDelProximo',lang)} {cup.rondas[cup.currentRound]}</Text>
          <Text>{transl('Cups.partidosJugados',lang)}</Text>
          <View>{resultsOfThisRound}</View>
          <Text>{transl('Cups.ganadorElMejor',lang,[cup.gamesPerRound,Math.ceil(cup.gamesPerRound/2)])}</Text>
        </View>
    } else if (cup.equipos[indicesEnCopa[0]].id == 1){
      return <View>
        <Text>{transl('Cups.hasAcabado1',lang)}</Text>
      </View>
    } else if (indicesEnCopa.length == 1){
      return <View>
        <Text>{transl('Cups.hasAcabado2',lang)}</Text>
      </View>
    } else {
      return <View>
        <Text>{transl('Cups.hasSidoDescalificado',lang)}</Text>
      </View>
    }
  }

  return <View><Text>{transl('Cups.pareceQueEsta',lang)}</Text></View>
}

export default CupInfo